// Load the text for the member's language before anything else, so the whole
// app — including labels built when a file loads — opens already translated.
// Then start the app (boot.js).
import { startingLanguage } from './i18n'
import { loadLanguageTable } from './i18n/tr'

loadLanguageTable(startingLanguage()).finally(() => import('./boot'))
